
import { Vue, Component } from 'vue-property-decorator'
import Option from '@/types/option'
import OptionShowDetailsTab from '@/views/option/tabs/show/OptionShowDetailsTab.vue'
import OptionShowImagesTab from '@/views/option/tabs/show/OptionShowImagesTab.vue'
import OptionShowDocumentsTab from '@/views/option/tabs/show/OptionShowDocumentsTab.vue'
import OptionShowSubelementsTab from '@/views/option/tabs/show/OptionShowSubelementsTab.vue'
import OptionShowEnabledIfTab from '@/views/option/tabs/show/OptionShowEnabledIfTab.vue'
import OptionShowDisabledIfTab from '@/views/option/tabs/show/OptionShowDisabledIfTab.vue'
import OptionShowSelectedIfTab from '@/views/option/tabs/show/OptionShowSelectedIfTab.vue'
import ActivityLogTable from '@/components/ActivityLogTable.vue'
import OptionShowBudgetsTab from '@/views/option/tabs/show/OptionShowBudgetsTab.vue'
import OptionAnalyticsTab from '@/views/option/tabs/OptionAnalyticsTab.vue'
import ls from '@/ls'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: { OptionAnalyticsTab, OptionShowBudgetsTab, ActivityLogTable, OptionShowSelectedIfTab, OptionShowDisabledIfTab, OptionShowEnabledIfTab, OptionShowSubelementsTab, OptionShowDocumentsTab, OptionShowImagesTab, OptionShowDetailsTab }
})

export default class OptionShow extends Vue {
  settings = {
    routeNames: { list: 'options', show: 'optionShow', edit: 'optionEdit' },
    routeParamKey: 'optionId',
    functionNames: { setCurrent: 'setCurrentOption', clearCurrent: 'clearCurrentOption', save: 'saveOption' },
    getterNames: { current: 'currentOption', loading: 'loadingOption' }
  }

  currentTab:string = ls.get('optionShowActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  setActiveTab (tab:string) : void {
    ls.set('optionShowActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Option {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
